import { render, staticRenderFns } from "./password-login.vue?vue&type=template&id=229e3d6e&scoped=true"
import script from "./password-login.vue?vue&type=script&lang=js"
export * from "./password-login.vue?vue&type=script&lang=js"
import style0 from "./password-login.vue?vue&type=style&index=0&id=229e3d6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e3d6e",
  null
  
)

export default component.exports